import styled from '@emotion/styled'

import { InteractiveBox } from 'components/ui/InteractiveBox'

export const SwitchBoxWrapper = styled(InteractiveBox)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:not(:last-of-type) {
    margin-bottom: 20px;
  }
`
